// src/pages/SensitiveSetting.jsx
import React, { Fragment, useContext, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Appfooter from "../components/Appfooter";
import { useTranslation } from "react-i18next";
import { useAPI } from "../context/ApiContext";
import { SnackbarContext } from "../context/SnackbarContext";

const SensitiveSetting = () => {
  const { t } = useTranslation();
  const api = useAPI();
  const { newSnack } = useContext(SnackbarContext);
  const current = useMemo(() => !!api?.clientSettings?.view_sensitive, [api?.clientSettings]);
  const [saving, setSaving] = useState(false);

  const setView = async (v) => {
    if (saving) return;
    setSaving(true);
    try {
      await api.updateMyClientSettings({ view_sensitive: v });
      newSnack("success", v ? (t("SensitiveSetting1") || "センシティブ閲覧をオンにしました") : (t("SensitiveSetting2") || "センシティブ閲覧をオフにしました"));
      try { await api.getMyClientSettings(); } catch {}
    } catch (e) {
      newSnack("error", t("SensitiveSetting3") || "保存に失敗しました");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Fragment>
      <Header />
      <Leftnav />

      <div className="main-content bg-lightblue theme-dark-bg right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="middle-wrap">
              <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                  <Link to="/settings" className="d-inline-block mt-2">
                    <i className="ti-arrow-left font-sm text-white"></i>
                  </Link>
                  <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                  {t("SensitiveSetting4")}
                  </h4>
                  {saving && <span className="ms-auto font-xssss text-white-50">{t("SensitiveSetting5")}</span>}
                </div>

                <div className="card-body p-lg-5 p-4 w-100 border-0">
                  <div className="nav-caption fw-600 font-xsss text-grey-500 mb-2">
                  {t("SensitiveSetting6")}
                  </div>

                  <div className="d-flex flex-wrap gap-2 mb-2">
                    <button
                      className={`btn ${current ? "bg-current text-white" : "btn-outline-primary"} font-xsss fw-600 p-3 rounded-3 me-2`}
                      onClick={() => setView(true)}
                      disabled={saving || current}
                    >
                      {t("SensitiveSetting7")}
                    </button>
                    <button
                      className={`btn ${!current ? "bg-current text-white" : "btn-outline-primary"} font-xsss fw-600 p-3 rounded-3`}
                      onClick={() => setView(false)}
                      disabled={saving || !current}
                    >
                      {t("SensitiveSetting8")}
                    </button>
                  </div>

                  {/* プレビュー枠 */}
                  <div className="card w-100 shadow-xss rounded-xxl border-light-md p-3">
                    <div className="position-relative">
                      <div
                        style={{
                          filter: current ? "none" : "blur(16px)",
                          pointerEvents: "none",
                          userSelect: "none",
                        }}
                      >
                        <div className="fw-600 text-grey-700 lh-26 font-xssss mb-2">
                        {t("SensitiveSetting9")}
                        </div>
                        <div className="card w-100 rounded-xxl border-light-md p-3">
                          <div className="font-xssss text-grey-600">example.com</div>
                          <div className="font-xsss fw-700 text-dark">Link preview title</div>
                          <div className="font-xssss text-grey-600">Link preview description here…</div>
                        </div>
                      </div>

                      {!current && (
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ position: "absolute", inset: 0 }}
                        >
                          <div className="bg-white shadow-lg rounded-xxl p-3 text-center" style={{ maxWidth: 520, width: "90%", opacity: 0.95 }}>
                            <div className="font-xsss fw-700 mb-2 text-danger">
                              {t("SensitiveSetting10") || "センシティブ"}
                            </div>
                            <div className="font-xssss text-grey-700 mb-2">
                              {t("SensitiveSetting11") || "成人向け、またはセンシティブな投稿です。閲覧するには設定から閲覧オンにしてください"}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="mt-2 font-xssss text-grey-600">
                      {t("SensitiveSetting12") || "閲覧オフのとき、タイムラインのセンシティブ投稿はブラーされ、中央に警告メッセージが表示されます。"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  

      <Appfooter />
    </Fragment>
  );
};

export default SensitiveSetting;
